export const DYNAMIC_LABELS = 'DYNAMIC_LABELS';

export function setDynamicLabelsData(dynamicLabelsData) {
  return {
    type: DYNAMIC_LABELS,
    dynamicLabelsData,
  };
}
